import React from "react";

type RoundCheckProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  id?: string;
  className?: string;
};

export default function RoundCheck({
  checked,
  onChange,
  label,
  id,
  className = "",
}: RoundCheckProps) {
  const generatedId = React.useId();
  const inputId = id || generatedId;

  return (
    <label
      htmlFor={inputId}
      className={["inline-flex items-center gap-2 cursor-pointer select-none", className].join(" ")}
    >
      <input
        id={inputId}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="sr-only"
      />
      <span
        className={[
          "inline-block h-5 w-5 rounded-full border transition-colors",
          checked ? "border-bright-green bg-bright-green" : "border-[#D3D3D3] bg-white",
        ].join(" ")}
      />
      <span className="text-sm text-black/70">{label}</span>
    </label>
  );
}

